import React from 'react';
import { browserHistory } from 'react-router';
import LoginStore from '../../stores/login-store';
import { isFreeTrialExpired } from '../../middleware/middleware';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';

export default class ChatButtonMarketing extends React.Component {
  constructor() {
    super();
    this.state = {
      visible: LoginStore.isLoggedIn()
    };
  }

  handleClick() {
    const { title } = this.props;

    // Check if user has access (logged in, free trial not expired)
    if (!LoginStore.isLoggedIn()) {
      this.requestRegisterModal();
      return;
    }

    if (isFreeTrialExpired(LoginStore.getSessionUserData())) {
      browserHistory.replace(`${window.location.pathname}?modal=upgrade`);
      return;
    }

    // Track the event
    PostHogService.capture(PostHogEvents.NAVIGATION_CLICKED, {
      item: 'Chat from Checklist',
      title: title
    });

    // Navigate to chat with pre-populated message
    browserHistory.push({
      pathname: '/chat',
      state: {
        prePopulatedMessage: `Tell me about: ${title}`
      }
    });
  }

  requestRegisterModal() {
    browserHistory.replace(`${window.location.pathname}?modal=register&restricted=1`)
  }

  render() {
    const isLoggedIn = this.state.visible;
    const buttonText = isLoggedIn ? "Ask Axon" : "Ask Axon (Login Required)";

    return (
      <button
        className="chat-button"
        onClick={this.handleClick.bind(this)}
        title={`Chat with Axon about: ${this.props.title}`}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
        <span>{buttonText}</span>
      </button>
    )
  }
}
